/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetBannersDataElementDto
 */
export interface GetBannersDataElementDto {
    /**
     * 배너 uuid
     * @type {string}
     * @memberof GetBannersDataElementDto
     */
    'bannerUuid': string;
    /**
     * 제목
     * @type {string}
     * @memberof GetBannersDataElementDto
     */
    'title': string;
    /**
     * 부제목
     * @type {string}
     * @memberof GetBannersDataElementDto
     */
    'subtitle': string;
    /**
     * 링크
     * @type {string}
     * @memberof GetBannersDataElementDto
     */
    'link'?: string;
    /**
     * 링크 타입
     * @type {string}
     * @memberof GetBannersDataElementDto
     */
    'linkType'?: GetBannersDataElementDtoLinkTypeEnum;
    /**
     * 이미지
     * @type {string}
     * @memberof GetBannersDataElementDto
     */
    'image': string;
}

export const GetBannersDataElementDtoLinkTypeEnum = {
    Self: 'self',
    Blank: 'blank'
} as const;

export type GetBannersDataElementDtoLinkTypeEnum = typeof GetBannersDataElementDtoLinkTypeEnum[keyof typeof GetBannersDataElementDtoLinkTypeEnum];


